/**
 * @fileOverView
 * @description Notification html reduced to a small allowlist before it reaches the page<br>
 * @copyright 2015-present Flatirontek LLC
 **/

'use strict';

// DOMParser's document is inert, so the input can be walked before any of it reaches the page, and
// serializing it closes every tag. The server cleans on the way in too; this covers older logs

const logText = require('../../../lib/logtext');

const ALLOWED_TAGS = logText.LOG_TAGS.map(tag => tag.toUpperCase());
// dropped with everything inside them; any other element is replaced by its children
const DROPPED_TAGS = ['SCRIPT', 'STYLE', 'TEMPLATE', 'IFRAME', 'OBJECT', 'EMBED', 'NOSCRIPT', 'SVG', 'MATH', 'TEXTAREA', 'SELECT'];
const LINK_ATTRIBUTES = ['href'].concat(logText.REVIEW_LINK_ATTRIBUTES);

function clean(node) {
    Array.from(node.childNodes).forEach(function(child) {
        if (child.nodeType === 3) return;
        const tag = child.nodeName.toUpperCase();
        if (child.nodeType !== 1 || DROPPED_TAGS.includes(tag)) {
            child.remove();
            return;
        }
        clean(child);
        if (!ALLOWED_TAGS.includes(tag)) {
            child.replaceWith.apply(child, Array.from(child.childNodes));
            return;
        }
        Array.from(child.attributes).forEach(function(attribute) {
            const keep = tag === 'A' && LINK_ATTRIBUTES.includes(attribute.name)
                && (attribute.name !== 'href' || logText.safeUrl(attribute.value) !== '');
            if (!keep) child.removeAttribute(attribute.name);
        });
    });
}

function sanitize(html) {
    if (typeof html !== 'string' || html.length === 0) return '';
    const body = new DOMParser().parseFromString(html, 'text/html').body;
    clean(body);
    return body.innerHTML;
}

module.exports = {sanitize};
